import React from 'react';

function ContactPage() {
  return (
    <div className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="section-title">Contact Us</h1>
        <p className="text-center text-lg text-gray-600 mb-12">
          We'd love to hear from you! Please reach out via email or LinkedIn below.
        </p>
        <div className="mt-12 text-center text-gray-600">
          <p className="text-lg font-semibold">KSL - Kornhill Services Ltd.</p>
          <p>Email: <a href="mailto:info@kornhill.ai" className="text-indigo-600 hover:underline">info@kornhill.ai</a></p>
          <p>LinkedIn: <a href="https://www.linkedin.com/company/kornhill-services-limited" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline">Kornhill Services Limited</a></p>
        </div>
      </div>
    </div>
  );
}

export default ContactPage; 